<template>
    <div v-if="orderDetailed" class="pt-5">
        <details-module 
          :order-detailed="orderDetailed" 
          :title="orderDetailed.siteName"
          :is-no-show="true"
          :is-cancelled="true"
          :return-to-profile-button="true"
          :can-see-receipt="true"
          layout="portal">
        </details-module>
    </div>
  </template>
  
  <script>
  import DetailsModule from './DetailsModule.vue'
  export default {
    components: { DetailsModule },
    computed: {
        orderDetailed() {
          return this.$route.params.order
        },
    },
    beforeDestroy() {
      this.$store.commit('setCreatedFairpay', null)
      this.$store.commit('setSession', null)
    }
}
  </script>
  